<template>
  <FormSubmitPopup
    :title="$t('addShipmentFromForecast')"
    v-model="value"
    @popupClose="$emit('closeCreateShipments')"
    large
    hideFooter>
    <template v-slot:input>
      <ToEveryone
        :selectedPackages="selectedPackages"
        :isSplitShipment="isSplitShipment"
        onlyOneLabel
        @submitted="submitted">
        <template v-slot:leftBtn>
          <v-btn dark color="primary" @click="$emit('closeCreateShipments')">{{ $t('close') }}</v-btn>
        </template>
      </ToEveryone>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import ToEveryone from './ToEveryone'

export default {
  name: 'ForecastAddShipment',
  components: {
    FormSubmitPopup,
    ToEveryone
  },
  methods: {
    submitted (payload) {
      this.$emit('updateBeforeShipments', payload)
      this.$emit('closeCreateShipments')
    }
  },
  props: {
    value: Boolean,
    selectedPackages: {
      type: Array,
      default: () => []
    },
    isSplitShipment: {
      default: false,
      type: Boolean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForecastAddShipment.vue